import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql, createRefetchContainer } from 'react-relay';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { addLoginHandlers } from 'dibs-buyer-layout/src/utils/loginHandlers';

import CartContainer from './CartContainer';

function CartRefetchContainerComponent(props) {
    // Default userId value is null because it's used only to decide if we need to refetch after login.
    // If user is already logged in we don't want to refetch. Items are already fetched.
    const [userId, updateUserId] = useState(null);
    const { addCartItemMutationCompleted, localCartItems, relay } = props;

    const hasLocalCartItems = !!localCartItems.length;

    useEffect(() => {
        addLoginHandlers(data => {
            const freshUserId = get(data, 'userId') || '';
            updateUserId(freshUserId);
        });
    }, []);

    useEffect(() => {
        const hasUserId = !!userId;
        const userIds = [userId];

        // Refetch cases:
        // - User just logged in and has nothing in his localStorage cart (localItems will be replaced with portfolioItems)
        // - User just logged in and has items in his localStorage cart (portfolioItems will be fetched with updated item from localStorage)
        // Don't need to refetch when user is already logged in and has portfolioItems already served
        if ((userId && addCartItemMutationCompleted) || (userId && !hasLocalCartItems)) {
            relay.refetch({
                hasUserId,
                userId,
                userIds,
                loadPortfolioData: true,
            });
        }
    }, [userId, addCartItemMutationCompleted, hasLocalCartItems, relay]);

    const { viewer } = props;
    const { user = null } = viewer;
    return <CartContainer localCartItems={props.localCartItems} viewer={viewer} user={user} />;
}

CartRefetchContainerComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    addCartItemMutationCompleted: PropTypes.bool,
    localCartItems: PropTypes.array,
};

const mapStateToProps = ({ cart }) => {
    const addCartItemMutationCompleted = !!get(cart, 'addCartItemMutationCompleted');
    const localCartItems = get(cart, 'items') || [];
    return { addCartItemMutationCompleted, localCartItems };
};
export const CartRefetchContainer = createRefetchContainer(
    connect(mapStateToProps)(CartRefetchContainerComponent),
    {
        viewer: graphql`
            fragment CartRefetchContainer_viewer on Viewer {
                ...CartContainer_viewer
                user(userId: $userId) @include(if: $hasUserId) {
                    ...CartContainer_user
                }
            }
        `,
    },
    graphql`
        query CartRefetchContainerQuery(
            $userId: String!
            $userIds: [String]!
            $hasUserId: Boolean!
            $localItemIds: [String]
            $fetchLocalItems: Boolean!
            $loadPortfolioData: Boolean!
        ) {
            viewer {
                ...CartRefetchContainer_viewer
            }
        }
    `
);
